import { TournamentType } from '@bg-components/Profile/enums';

export const getTournamentPriority = (
    currentDate: Date,
    activeFrom: Date,
    disabledFrom: Date,
): TournamentType => {
    if (activeFrom <= currentDate && currentDate < disabledFrom) {
        return TournamentType.ONGOING;
    }

    if (currentDate < activeFrom) {
        return TournamentType.UPCOMING;
    }

    return TournamentType.COMPLETED;
};
